module.exports = __webpack_public_path__ + "static/media/nichole.029905ce.png";